/**
 *Core
 */
import { ContextProfileUser } from "../../lib/profileContext";
import { useContext, useState } from "react";
import InputGlobal from "../InputGlobal";
import { simplyClick, validateEmail } from "../../helpers";

/**
 *Styles
 */
import "./Email.scss";
import StepWrapper from "../StepWrapper";
import ButtonGlobal from "../ButtonGlobal";

const Email = ({ step, setStep }) => {
  const { data, setData } = useContext(ContextProfileUser);
  const [errorEmail, setErrorEmail] = useState(null);
  const [loader, setLoader] = useState(false);

  const domains = [
    "@gmail.com",
    "@yahoo.com",
    "@hotmail.com",
    "@aol.com",
    "@outlook.com",
    "@comcast.net",
    "@live.com",
    "@mail.com",
    "@msn.com",
    "@att.net",
    "@icloud.com",
  ];

  const handlerSubmit = () => {
    setLoader(true);

    validateEmail(data.email, (result) => {
      const { status, error } = result;
      setLoader(false);
      if (!status) {
        setErrorEmail(error);
      } else {
        simplyClick("cl_lnd_am31_email_cont", { email: data?.email });
        setStep(step + 1);
      }
    });
  };
  const handlerStepBack = () => {
    setStep(step - 1);
    simplyClick("cl_lnd_am31_email_back", null);
  };

  const handleAddEmail = (e) => {
    setEmailValue(e.target.value);
  };

  const setEmailValue = (value) => {
    setErrorEmail(null);
    setData({ ...data, email: value });
  };

  const setFullEmail = (fullEmail) => {
    setErrorEmail(null);
    setData({ ...data, email: fullEmail });
  };

  return (
    <>
      {loader && (
        <div className="spin-loader">
          <span>Loading...</span>
        </div>
      )}
      <StepWrapper step={step} stepLabel={"Please enter your valid email"}>
        <div className="email_input">
          <div className="has-float-label">
            <InputGlobal
              className={
                "input__global" +
                (errorEmail ? " error" : "") +
                (data.email?.length > 0 && !data.email?.includes("@")
                  ? " active"
                  : "")
              }
              onChange={(e) => handleAddEmail(e)}
              name={"email__30"}
              placeholder={"Your email"}
              type={"text"}
              id={"email__30"}
              value={data.email ? data.email : ""}
            />
            {data.email?.length > 0 && !data.email?.includes("@") && (
              <div className="autocomplete__box">
                <ul className="autocomplete__box-list">
                  {domains.map((domain, index) => (
                    <li
                      onClick={() => setFullEmail(data.email + domain)}
                      className="autocomplete__box-list-item"
                      key={index}
                    >
                      {data.email}
                      {domain}
                    </li>
                  ))}
                </ul>
              </div>
            )}
            <label htmlFor="email__30" className={errorEmail ? "error" : ""}>
              Your email
            </label>
          </div>
          {errorEmail && <p className="error-text">{errorEmail}</p>}
        </div>
        <div className="button_wrap">
          <ButtonGlobal text={"Continue"} cb={handlerSubmit} />
          <ButtonGlobal
            text={"Back"}
            cb={handlerStepBack}
            back={true}
            iconLeft={true}
          />
        </div>
      </StepWrapper>
    </>
  );
};
export default Email;
